module.exports = __webpack_public_path__ + "img/mono-copy.00e5834e.svg";